import { OwnUpHeader } from '@rategravity/own-up-component-library';
import React from 'react';

export const UnauthHeader = () => {
  return <OwnUpHeader variant="title">Unlucky :(</OwnUpHeader>;
};
